// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/static_pages/legal.less
// module id = 1226
// module chunks = 0